import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "./AboutPage.css";
import Footer from "../components/Footer";

const fadeLeft  = { initial:{opacity:0,x:-60}, whileInView:{opacity:1,x:0}, transition:{duration:.7}, viewport:{once:true} };
const fadeRight = { initial:{opacity:0,x:60},  whileInView:{opacity:1,x:0}, transition:{duration:.7}, viewport:{once:true} };
const fadeUp    = { initial:{opacity:0,y:24},  whileInView:{opacity:1,y:0}, transition:{duration:.6}, viewport:{once:true} };

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <><main className="about">
          {/* Hero */}
          <section className="about-hero container">
              <motion.div className="about-hero__text" {...fadeLeft}>
                  <h1>{t("AboutPage.Title")}</h1>
                  <p dangerouslySetInnerHTML={{ __html: t("AboutPage.Intro1") }} />
                  <p dangerouslySetInnerHTML={{ __html: t("AboutPage.Intro2") }} />
              </motion.div>

              <motion.aside className="about-hero__card" {...fadeRight}>
                  <div className="about-hero__stat"><strong>2020</strong><span>{t("AboutPage.StatRoots")}</span></div>
                  <div className="divider" />
                  <div className="about-hero__stat"><strong>2025</strong><span>{t("AboutPage.StatAB")}</span></div>
                  <div className="divider" />
                  <div className="about-hero__stat"><strong>50+</strong><span>{t("AboutPage.StatProjects")}</span></div>
              </motion.aside>
          </section>

          {/* What we do */}
          <section className="about-grid container">
              <header className="section-head">
                  <h2>{t("AboutPage.WhatWeDoTitle")}</h2>
                  <p className="muted">{t("AboutPage.WhatWeDoLead")}</p>
              </header>

              <div className="grid">
                  {["Web", "Apps", "UX", "Consulting"].map((k, idx) => (
                      <motion.article key={k} className="card" {...fadeUp} transition={{ duration: .5, delay: .08 * idx }}>
                          <h3>{t(`AboutPage.What.${k}.Title`)}</h3>
                          <p>{t(`AboutPage.What.${k}.Body`)}</p>
                      </motion.article>
                  ))}
              </div>
          </section>

          {/* Mission & Vision */}
          <section className="about-split container">
              <motion.article className="card accent" {...fadeLeft}>
                  <h3>{t("AboutPage.MissionTitle")}</h3>
                  <p>{t("AboutPage.MissionBody")}</p>
              </motion.article>
              <motion.article className="card accent" {...fadeRight}>
                  <h3>{t("AboutPage.VisionTitle")}</h3>
                  <p>{t("AboutPage.VisionBody")}</p>
              </motion.article>
          </section>

          {/* Process */}
          <section className="about-steps container">
              <header className="section-head">
                  <h2>{t("AboutPage.ProcessTitle")}</h2>
                  <p className="muted">{t("AboutPage.ProcessLead")}</p>
              </header>

              <ol className="steps">
                  {["Discover", "Design", "Build", "Launch"].map((k, idx) => (
                      <motion.li key={k} className="step" {...fadeUp} transition={{ duration: .5, delay: .08 * idx }}>
                          <h4>{t(`AboutPage.Process.${k}.Title`)}</h4>
                          <p>{t(`AboutPage.Process.${k}.Body`)}</p>
                      </motion.li>
                  ))}
              </ol>
          </section>

          {/* Values */}
          <section className="about-grid container">
              <header className="section-head">
                  <h2>{t("AboutPage.ValuesTitle")}</h2>
                  <p className="muted">{t("AboutPage.ValuesLead")}</p>
              </header>

              <div className="grid">
                  {["Clarity", "Craft", "Security", "LongTerm"].map((k, idx) => (
                      <motion.article key={k} className="card" {...fadeUp} transition={{ duration: .5, delay: .08 * idx }}>
                          <h3>{t(`AboutPage.Values.${k}.Title`)}</h3>
                          <p>{t(`AboutPage.Values.${k}.Body`)}</p>
                      </motion.article>
                  ))}
              </div>
          </section>

          {/* Timeline */}
          <section className="about-timeline container">
              <header className="section-head">
                  <h2>{t("AboutPage.TimelineTitle")}</h2>
                  <p className="muted">{t("AboutPage.TimelineLead")}</p>
              </header>

              <div className="timeline">
                  {["2020", "2022", "2025"].map((year, idx) => (
                      <motion.div key={year} className="tl-item" {...fadeUp} transition={{ duration: .5, delay: .06 * idx }}>
                          <div className="tl-dot" />
                          <div className="tl-content">
                              <h4>{t(`AboutPage.Timeline.${year}.Title`)}</h4>
                              <p>{t(`AboutPage.Timeline.${year}.Body`)}</p>
                          </div>
                      </motion.div>
                  ))}
              </div>
          </section>

          {/* CTA */}
          <section className="about-cta container">
              <motion.div className="cta-card" {...fadeUp}>
                  <h2>{t("AboutPage.CTATitle")}</h2>
                  <p>{t("AboutPage.CTABody")}</p>
                  <div className="cta-actions">
                      <a className="btn btn-primary" href="/contact">{t("AboutPage.CTAStart")}</a>
                      <a className="btn btn-ghost" href="/services">{t("AboutPage.CTAExplore")}</a>
                  </div>
              </motion.div>
          </section>
      </main>
      <Footer /></>
  );

  
}